import Link from '../../views/PasswordForgotMsg';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';

const mapStateToProps = (state, ownProps) => ({
  intel: ownProps.match.params.intel,
  locale: ownProps.match.params.locale,
  status: state.shift.status
});

const mapDispatchToProps = (dispatch, ownProps) => {
  const { locale } = ownProps.match.params;

  return {
    clickLoginHandler: value => {
      //console.log(value);
      dispatch(push(`/${locale}/login`));
    }
  };
};

const PasswordForgotMsg = connect(
  mapStateToProps,
  mapDispatchToProps
)(Link);

export default PasswordForgotMsg;



// WEBPACK FOOTER //
// ./src/components/container/PasswordForgotMsg/index.js